import * as R from 'ramda';

export default function SyncControlConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  controlDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmSync = _handleConfirmSync;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmSync($event) {
    loaderService.showViewLoader = true;
    const controlIds = [];
    const syncDTO = {
      customerId: vm.controlType.customerId,
      customerControlTypeId: vm.controlType.customerControlTypeId,
      syncAllCustomerControls: false,
      syncAllCustomerControlsForAssetType: false,
      customerControlIds: controlIds,
    };
    if (!vm.isMultipleControls) {
      controlIds.push(vm.control.customerControlId);
      syncDTO.customerControlIds = controlIds;
    } else {
      R.forEach(
        (item) => {
          controlIds.push(item.customerControlId);
        },
        vm.controls
      );
      syncDTO.customerControlIds = controlIds;
    }
    return controlDataService.syncControl(syncDTO)
      .then(() => {
        if (!vm.isMultipleControls) {
          alerts.success(`The control "${vm.control.name}" was successfully synced.`);
        } else {
          alerts.success('The controls were successfully synced.');
        }
        if (vm.updateCallBack) {
          vm.updateCallBack();
        }
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while syncing the control.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.controlAdmin.syncControlDialog);
  }
}

SyncControlConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'controlDataService',
  'loaderService',
  'ssDialogService'
];
